import { DatePipe as AngularDatePipe } from '@angular/common'
import { OnDestroy, Pipe, PipeTransform } from '@angular/core'
import { utcToZonedTime } from 'date-fns-tz'
import { Subscription } from 'rxjs'
import { I18nConfigService } from '../../../core/services/i18n-config.service'
import { ScopeService } from '../../../core/services/scope.service'

@Pipe({
    name: 'appLocaleScopeTimezoneDate',
    standalone: false
})
export class AppLocaleScopeTimezoneDatePipe implements PipeTransform, OnDestroy {

  private angularDatePipe: AngularDatePipe
  private ianaTimezone: string | undefined

  subscriptions: Subscription[] = [
    this.i18nConfigService.selectedLanguage$.subscribe(selectedLanguage => {
      this.angularDatePipe = new AngularDatePipe(selectedLanguage)
    }),
    this.scopeService.scope$.subscribe(scope => {
      this.ianaTimezone = scope ? scope.ianaTimeZone : undefined
    })
  ]

  constructor (
    private i18nConfigService: I18nConfigService,
    private scopeService: ScopeService,
  ) {}

  transform(value: Date | string | number, format?: string): string | null
  transform(value: null | undefined, format?: string): null
  transform (value: Date | string | number | null | undefined, format?: string): string | null {
    if(this.ianaTimezone === undefined) throw Error('timezone is undefined')
    if(value === null || value === undefined) return this.angularDatePipe.transform(value, format, this.ianaTimezone)
    // FIXME: angular date pipe not taking timezone into consideration we have to use date-fns-tz
    return this.angularDatePipe.transform(utcToZonedTime(value, this.ianaTimezone), format)
  }

  ngOnDestroy (): void {
    this.subscriptions.forEach(subscription=>subscription.unsubscribe())
  }
}
